<template src="@/templates/file/uploadForm.html"></template>

<script>
import { downloadFileMixin } from "@/mixins/functions/downloadFileMixin";
import ServiceDeliveryFormModel from "@/models/serviceDeliveryFormModel";

export default {
  name: "uploadForm",
  props: ["fileList", "ref_num"],
  mixins: [downloadFileMixin],
  data() {
    return {
      serviceDeliveryFormModel: new ServiceDeliveryFormModel(),
      uploadFormPopUp: true,
      pushTo: "uploadForm",
      uploaded_file: {},
    };
  },
  created() {
    // this.uploaded_file = this.fileList[0];
    this.uploaded_file = this.fileList.dataUrl;
    // this.percent_done = 0;
    // this.start_point = 0;
    // this.next_slice = 0;
    // this.previewImage = this.fileList.dataUrl;

    this.checkIfChunkRequired;
  },
  methods: {
    closeUploadForm(defaultComp = "hideUploadFormComp") {
      this.reset();
      Event.$emit(defaultComp);
    },
    reset() {
      this.resetAll;
    },
    uploadFile() {
      this.size_of_chunked_file = this.chunkFiles[this.pushTo].length;

      if (this.size_of_chunked_file === 1) {
        this.finished_uploading = 1;
      }

      this.serviceDeliveryFormModel.data = {
        base64: this.chunkFiles[this.pushTo][this.uploading_file_started],
        finished_uploading: this.finished_uploading,
        file_name: this.uploaded_file_name,
        type: this.mime_type,
        ext: this.fileExtension,
      };

      if (this.serviceDeliveryFormModel.data.base64 === "") {
        let error = "Error with uploaded file. Try again";
        this.validationError(error);
        return;
      }

      this.serviceDeliveryFormModel.ref_num = this.ref_num;

      this.serviceDeliveryFormModel
        .saveFile()
        .then((SDFModelRes) => {
          let response = SDFModelRes.response.data;
          if (response.error === false) {
            if (
              this.size_of_chunked_file == 1 ||
              this.finished_uploading == 1
            ) {
              console.log("Just 1 chunked items of file or finished uploading");
              console.log("Upload Done successfully");
              this.successMessage();
              this.closeUploadForm("backToUploadDetailsComp");
              this.reset();
            } else {
              this.update_the_states();
            }
          } else {
            let errorMessage = "Upload error. " + response.message;
            this.saveError(errorMessage);
          }
        })
        .catch((PCError) => {
          let errorMessage = "Network error. " + PCError;
          this.saveError(errorMessage);
          console.error(PCError);
        });
    },
    update_the_states() {
      if (this.finished_uploading == 0) {
        this.uploading_file_started++;

        if (this.uploading_file_started == this.size_of_chunked_file - 1) {
          console.log("Finished the recursive call");
          this.finished_uploading = 1;
        } else {
          console.log("Recurrsive call of function");
        }
      }

      this.uploadFile();
    },
    successMessage() {
      this.$vs.notify({
        title: "Upload Success",
        text: "Successfully Saved",
        time: 4000,
        color: "success",
        position: "top-center",
      });
    },
    saveError(errorMessage) {
      this.$vs.notify({
        title: "Network Error",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
    validationError(errorMessage) {
      this.$vs.notify({
        title: "Network Error",
        text: errorMessage,
        time: 4000,
        color: "danger",
        position: "top-center",
      });
    },
  },
};
</script>
